<template>
    <td v-if="!dataItem['inEdit']">
            
        <span v-if="editOperations.edit ">
            <button
                v-if="dataItem['ReadOnlyM'] < 1 || dataItem['ReadOnlyM'] === undefined"
                class="k-primary k-button k-grid-edit-command"
                @click="editHandler"
                >
                Edit
            </button>
        </span>
        <button
            v-if="editOperations.edit"
            class="k-button k-grid-remove-command"
            @click="printHandler">
            Print
        </button>
        
        <button
            v-if="editOperations.remove"
            class="k-button k-grid-remove-command"
            @click="removeHandler">
            Remove
        </button>
        
        <div  v-if="editOperations.remove" id="printable-content">
            <h1>Hello bro</h1>
        </div>
    </td>
    <td v-else>
        <button
            class="k-button k-grid-save-command"
            @click="addUpdateHandler">
            {{this.dataItem[idField]? 'Update' : 'Add'}}
        </button>
        <button
            class="k-button k-grid-cancel-command"
            @click="cancelDiscardHandler">
            {{this.dataItem[idField]? 'Cancel' : 'Discard'}}
        </button>
    </td>
</template>

<script>

class NombreEnLettres {
    nombreEnLettres(nombre) {
      if (nombre < 0) {
        return "moins " + this.nombreEnLettres(-nombre);
      }
      
      if (nombre === 0) {
        return "zéro";
      }
      
      let resultat = "";
      
      if (nombre >= 1000000000) {
        const milliards = Math.floor(nombre / 1000000000);
        const reste = nombre % 1000000000;
        resultat = this.traiterCentaines(milliards) + " milliard" + (milliards > 1 ? "s" : "");
        if (reste > 0) {
          resultat += " " + this.nombreEnLettres(reste);
        }
      } else if (nombre >= 1000000) {
        const millions = Math.floor(nombre / 1000000);
        const reste = nombre % 1000000;
        resultat = this.traiterCentaines(millions) + " million" + (millions > 1 ? "s" : "");
        if (reste > 0) {
          resultat += " " + this.nombreEnLettres(reste);
        }
      } else if (nombre >= 1000) {
        const milliers = Math.floor(nombre / 1000);
        const reste = nombre % 1000;
        if (milliers === 1) {
          resultat = "mille";
        } else {
          resultat = this.traiterCentaines(milliers) + " mille";
        }
        if (reste > 0) {
          resultat += " " + this.nombreEnLettres(reste);
        }
      } else {
        resultat = this.traiterCentaines(nombre);
      }
      
      return resultat;
    }
    
    traiterCentaines(nombre) {
      if (nombre < 100) {
        return this.traiterDizaines(nombre);
      }
      
      const centaines = Math.floor(nombre / 100);
      const reste = nombre % 100;
      
      if (centaines === 1) {
        var resultat = "cent";
      } else {
        resultat = this.traiterUnites(centaines) + " cent" + (reste === 0 && centaines > 1 ? "s" : "");
      }
      
      if (reste > 0) {
        resultat += " " + this.traiterDizaines(reste);
      }
      
      return resultat;
    }
    
    traiterDizaines(nombre) {
      if (nombre < 10) {
        return this.traiterUnites(nombre);
      }
      
      if (nombre >= 10 && nombre <= 19) {
        const dizainesSpeciales = ["dix", "onze", "douze", "treize", "quatorze", "quinze", "seize", 
                                 "dix-sept", "dix-huit", "dix-neuf"];
        return dizainesSpeciales[nombre - 10];
      }
      
      const dizaines = Math.floor(nombre / 10) * 10;
      const unite = nombre % 10;
      
      if (dizaines === 70 || dizaines === 90) {
        const base = (dizaines === 70 ? "soixante" : "quatre-vingt");
        if (unite === 0) {
          return base + (dizaines === 70 ? "-dix" : "-dix");
        } else {
          const dixANeuf = ["dix", "onze", "douze", "treize", "quatorze", "quinze", 
                           "seize", "dix-sept", "dix-huit", "dix-neuf"];
          return base + "-" + dixANeuf[unite];
        }
      }
      
      const dizainesTab = {
        20: "vingt", 
        30: "trente", 
        40: "quarante", 
        50: "cinquante", 
        60: "soixante", 
        80: "quatre-vingt"
      };
      resultat = dizainesTab[dizaines];
      
      if (dizaines === 80 && unite === 0) {
        return resultat + "s"; // "quatre-vingts"
      }
      
      if (unite === 0) {
        return resultat;
      }
      
      if (unite === 1 && dizaines !== 80 && dizaines !== 90) {
        return resultat + " et un";
      }
      
      if ([20, 30, 40, 50, 60].includes(dizaines) && unite === 1) {
        return resultat + " et un";
      }
      
      return resultat + "-" + this.traiterUnites(unite);
    }
    
    traiterUnites(nombre) {
      if (nombre === 0) {
        return "";
      }
      
      const unites = ["un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf"];
      return unites[nombre - 1];
    }
  }
export default {
    name: 'inline-commands',
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        idField: String,
        editOperations: Object
    },
    methods: {
        editHandler: function() {
            this.$emit('edit', {dataItem:this.dataItem});
        },
        formatDate:function(date) {
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const dayName = days[date.getDay()];
            const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            const monthName = months[date.getMonth()]; // "March"
            const day = date.getDate();
            //const month = date.toLocaleString('default', { month: 'long' });
            const year = date.getFullYear();
            return `${dayName}, ${day} ${monthName} ${year}`;
         },
        printHandler: function() {
            const dateObj        = new Date(this.dataItem.MoneyMovebDate);
            const dateCreate     = this.formatDate(dateObj);
            const note           = this.dataItem.Note;
            const description    = this.dataItem.MoneyMovebCategorieFID;
            const voucher        = this.dataItem.Vouchers;
            const city           = this.dataItem.ville.Ville;
            const devise         = this.dataItem.currency.Currency;
            const devise_label   = this.dataItem.currency.CurrencyId != 1 ? "Francs" : "Dollars";
            const msgTypeBon     = this.dataItem.Credit ? "d'entrée " : "de sortie ";
            const amount         = this.dataItem.Credit ? this.dataItem.Credit : this.dataItem.Debit
            const convertisseur  = new NombreEnLettres().nombreEnLettres(amount);
            const now = new Date();

            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

            const dayName = days[now.getDay()]; // "Friday"
            const day = String(now.getDate()).padStart(2, '0'); // "28"
            const monthName = months[now.getMonth()]; // "March"
            const year = now.getFullYear(); // "2025"

            let hours = now.getHours();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convertit en 12h
            hours = String(hours).padStart(2, '0'); // "09"
            const minutes = String(now.getMinutes()).padStart(2, '0'); // "28"

            const formattedDate = `${dayName}, ${day} ${monthName} ${year} ${hours}:${minutes} ${ampm}`;
            const printContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${city}</title>
    </head>
        <body>
       <div class="receipt">
        <div><span style="position:absolute;right:60px;font-size:19px;top:-5px"><b>${city}</b></span></div>
        <br/>
    <div class="voucher-item" >
        <span><b><u>Le :</u> ${dateCreate}</b></span>
       <div class="connected-elements">
         <div class="element left-element" style="padding-right:10px;"><b><u>Vouchers:</u></b></div>
           <div class="element right-element" style="padding-right:70px"><b>${voucher}</b></div>
        </div>
    </div>
       <div class="connected-elements">
           <b><u>Montant :</u></b>
           <div class="element left-element" style="padding-right:70px;margin-left:13px"><b>${parseFloat(amount)}</b></div>
           <div class="element right-element" style="padding-right:30px"><b>${devise}</b></div>
       </div>
    
    <div class="header">
        <h1><u>Bon ${msgTypeBon} Caisse</u></h1>
    </div>
    
    <span class="textList"><b><u>Ste/Ets</u></b></span>
    <div class="element"  style="width: 100%; height: 50px;margin-top:5px;margin-bottom:10px"><b>${description}</b></div>    
    <span><b><u>Somme (en lettres)</u></b></span>
         <div  class="element"  style="width: 100%; height: 40px;margin-top:5px;margin-bottom:10px"><b>${convertisseur} ${devise_label}</b></div>
    <span><b><u>Motif</u></b></span>
     <div  class="element"  style="width: 100%; height: 40px;margin-top:5px;margin-bottom:5px"><b>${note}</b></div>
    <div style="margin-bottom: 85px;" class="voucher-item signatures">
        <span><b><u>Sign. de Client</u></b></span>
        <span><b><u>Sign. de l'agent</u></b></span>
    </div>
    
    <span style="font-size:8px;">${formattedDate}</span>
    <div class="section">
    </div>
     
</div>
    `;
    
    // Ouvrir la fenêtre d'impression
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      
          <style>
        body {
            font-family: 'serif';
            max-width: 600px;
            margin: 0 auto;
            padding: 20px;
            color: #333;
            background-color: #f9f9f9;
        }
            .connected-elements {
              display: flex;
              align-items: center;
              gap: 0px; /* Espace entre les éléments */
        }

       .element {
          padding: 2px 2px;
          border: 1px solid #D3D3D3;
          border-radius: 1px;
        }
        .receipt {
            background-color: white;
        }
        .receipt:before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 5px;
            height: 100%;
            background: linear-gradient(to bottom, #3498db, #2ecc71);
        }
        .header {
            margin-bottom: 10px;
            margin-top: 16px;
            text-align: center;
        }
        .header h1 {
            color: #2c3e50;
            margin: 0;
            font-size: 18px;
        }
        .header .date {
            color: #7f8c8d;
            font-weight: bold;
            margin: 2px 0 15px;
        }
        .amount {
            font-size: 15px;
            font-weight: bold;
        }
        .section {
            margin-bottom: 20px;
            border-bottom: 1px dashed black;
            padding-bottom: 15px;
        }
        .section h2 {
            color: #3498db;
            font-size: 18px;
            margin-bottom: 10px;
        }
        .voucher {
            background-color: #f8f9fa;
            padding: 12px;
            border-radius: 8px;
            margin-bottom: 15px;
        }
        .voucher h3 {
            margin-top: 0;
            color: #2c3e50;
            font-size: 16px;
        }
        .voucher-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 1px;
        }
        .signature-section {
            margin-top: 25px;
        }
        .signature-line {
            border-top: 1px solid #ddd;
            margin: 30px 0 15px;
            padding-top: 10px;
        }
        .signature-label {
            font-weight: bold;
            color: #7f8c8d;
        }
    </style>
        <body>${printContent}</body>
   
    `);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500)
        },
        removeHandler: function() {
            this.$emit('remove', {dataItem:this.dataItem});
        },
        addUpdateHandler: function() {
            this.$emit('save', {dataItem:this.dataItem});
        },
        cancelDiscardHandler: function() {
            this.$emit('cancel', {dataItem:this.dataItem});
        }
    }
};
</script>